import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

import Tasks from 'APP/Tasks';
import {
  IDeleteRecurrenceEventParams,
  CalendarModelErrorCode,
} from 'APP/model/calendar/calendar.types';
import { calendarModel } from 'APP/model/model';

export const deleteRecurrenceCalendarEvent = async (
  params: IDeleteRecurrenceEventParams
): Promise<boolean> => {
  try {
    const response = await calendarModel.deleteRecurrenceCalendarEvent(params);

    popupsTasks.showToast(t('calendar_event_delete_success'));

    if (!response) {
      throw new Error();
    }

    return true;
  } catch (error) {
    if (error.message === CalendarModelErrorCode.Unauthorized) {
      Tasks.calendar.handleCalendarUnauthorized();
    }
    popupsTasks.showToast(t('something_went_wrong'));

    return false;
  }
};
